import React from 'react';
import PropTypes from 'prop-types';

import {
  QuestionLabel,
  TextError,
  Container,
} from '../styles';

import {
  Form,
  TextArea,
  FormField,
} from './styles';

const WrittenQuestionType = (props) => {
  const {
    label,
    placeholder,
    errorText,
    onChange,
    selectedValue,
    errorField,
  } = props;

  const onChangeInput = (e, { value }) => {
    onChange(value);
  };

  return (
    <Container>
      <QuestionLabel>{label}</QuestionLabel>

      <Form>
        <FormField
          data-tester-written-question
          control={TextArea}
          onChange={onChangeInput}
          placeholder={placeholder}
          value={selectedValue || ''}
          error={errorField}
        />
      </Form>

      {errorField && (
        <TextError>
          {errorText}
        </TextError>
      )}

    </Container>
  );
};

WrittenQuestionType.propTypes = {
  placeholder: PropTypes.string,
  errorText: PropTypes.string,
  onChange: PropTypes.func,
  selectedValue: PropTypes.string,
  label: PropTypes.string.isRequired,
  errorField: PropTypes.bool,
};

WrittenQuestionType.defaultProps = {
  placeholder: 'Type your answer',
  errorText: 'Please write an answer',
  onChange: () => { },
  selectedValue: '',
  errorField: false,
};

export default WrittenQuestionType;
